import { useState } from "react";
import { Button } from "../components/Button";
import { HelpButton } from "../components/HelpButton";
import { GlobeIcon } from "../components/Icons";
import { Modal } from "../components/Modal";
import { useUiText } from "../i18n/useUiText";
import { useAppStore } from "../state/useAppStore";

export function HomeScreen() {
  const t = useUiText();
  const [resetOpen, setResetOpen] = useState(false);
  const [tutorialOpen, setTutorialOpen] = useState(false);
  const uiLanguage = useAppStore((state) => state.uiLanguage);
  const setUiLanguage = useAppStore((state) => state.setUiLanguage);
  const session = useAppStore((state) => state.session);
  const selectedSeat = useAppStore((state) => state.selectedSeat);
  const openCreate = useAppStore((state) => state.openCreate);
  const openJoin = useAppStore((state) => state.openJoin);
  const resumeSession = useAppStore((state) => state.resumeSession);
  const resetSession = useAppStore((state) => state.resetSession);

  return (
    <div className="app-shell home-screen">
      <header className="app-header app-header--floating">
        <div className="app-header__leading" />
        <div className="app-header__actions">
          <Button
            aria-label={t("language.switch")}
            className="language-button"
            icon={<GlobeIcon />}
            onClick={() => setUiLanguage(uiLanguage === "zh" ? "en" : "zh")}
            variant="ghost"
          >
            {t("language.short")}
          </Button>
          <HelpButton />
        </div>
      </header>

      <main className="screen-content home-content">
        <div className="home-brand">
          <p className="eyebrow">{t("app.eyebrow")}</p>
          <h1 className="home-brand__title">{t("app.title")}</h1>
        </div>

        <div className="home-actions">
          {session !== null ? (
            <div className="resume-card">
              <strong className="resume-card__summary">
                {t("home.resumeSummary", {
                  theme: session.theme.title,
                  seat: selectedSeat ?? "—"
                })}
              </strong>
              <Button onClick={resumeSession} variant="primary" wide>
                {t("home.resumeAction")}
              </Button>
              <Button
                onClick={() => setResetOpen(true)}
                variant="secondary"
                wide
              >
                {t("home.newAction")}
              </Button>
            </div>
          ) : (
            <div className="home-primary-actions">
              <Button onClick={openCreate} variant="primary" wide>
                {t("home.createAction")}
              </Button>
              <Button onClick={openJoin} variant="secondary" wide>
                {t("home.joinAction")}
              </Button>
            </div>
          )}
        </div>
      </main>

      <Button className="home-tutorial" onClick={() => setTutorialOpen(true)} variant="ghost">
        {t("tutorial.open")}
      </Button>

      <Modal
        closeLabel={t("common.close")}
        description={t("tutorial.body")}
        footer={
          <Button onClick={() => setTutorialOpen(false)} wide>
            {t("tutorial.dismiss")}
          </Button>
        }
        onClose={() => setTutorialOpen(false)}
        open={tutorialOpen}
        title={t("tutorial.title")}
      />

      <Modal
        closeLabel={t("common.close")}
        description={t("reset.body")}
        footer={
          <>
            <Button onClick={() => setResetOpen(false)} variant="secondary">
              {t("common.cancel")}
            </Button>
            <Button
              onClick={() => {
                resetSession();
                setResetOpen(false);
              }}
              variant="danger"
            >
              {t("reset.confirm")}
            </Button>
          </>
        }
        onClose={() => setResetOpen(false)}
        open={resetOpen}
        title={t("reset.title")}
      />
    </div>
  );
}
